import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';

import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  sampleRate: 0.01,
  tracesSampleRate: 0.01,
});

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
